import React from 'react';
import { useCookieConsent } from '../contexts/CookieConsentContext';

/**
 * Cookie Manager component - Development Tools Only
 * Simple debug tools for cookie consent testing
 */
const CookieManager: React.FC = () => {
  const { consent, resetConsent } = useCookieConsent();

  const handleResetConsent = () => {
    if (window.confirm('Are you sure you want to reset your cookie preferences? This will show the cookie banner again.')) {
      resetConsent();
    }
  };

  return (
    <>

      {/* Debug Tools (Development Only) */}
      {process.env.NODE_ENV === 'development' && (
        <div className="text-xs space-x-2">
          <button
            onClick={handleResetConsent}
            className="text-red-400 hover:text-red-300 transition-colors"
            title="Reset cookie consent (dev only)"
          >
            Reset Consent
          </button>
          <button
            onClick={() => console.log('Cookie consent:', consent)}
            className="text-blue-400 hover:text-blue-300 transition-colors"
            title="Log consent to console (dev only)"
          >
            Log Consent
          </button>
        </div>
      )}
    </>
  );
};

export default CookieManager;